import React from "react";
import { createRoot } from "react-dom/client";
import { logger } from "@tecma/logs-fe";
import { ErrorPage, DeviceContext } from "@tecma/ds";
import { ErrorBoundary } from "react-error-boundary";

import { Providers } from "./components/Providers/Providers";
import { getProjectLogoUrl } from "./utils/project";
import reportWebVitals from "./reportWebVitals";
import { storeFactory } from "./store";
import { instantiateRepositories } from "./store/domain";
import App from "./App";

// Polyfill per setImmediate se non disponibile
if (typeof setImmediate === "undefined") {
  (
    global as unknown as { setImmediate: (callback: () => void) => void }
  ).setImmediate = setTimeout;
}

const store = storeFactory();
const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
export const repos = instantiateRepositories(store);
const currentLanguage = localStorage.getItem("i18nextLng") ?? undefined;
const environment = store.getState().environmentState;

root.render(
  <React.StrictMode>
    <ErrorBoundary
      FallbackComponent={() => (
        <ErrorPage
          logo={getProjectLogoUrl(environment.REACT_APP_BUCKET_BASEURL)}
          language={currentLanguage}
        />
      )}
      onError={(error) => {
        logger.error("APPLICATION_ERROR", error);
      }}
    >
      <Providers>
        <DeviceContext>
          <App />
        </DeviceContext>
      </Providers>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
